// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/avatar/style/index.less
// module id = 1011
// module chunks = 0